export default {
  welcome: {
    en: "Welcome!",ch: "歡迎！",
    ja: "ようこそ！"
  }
}
